document.addEventListener('DOMContentLoaded', function() {

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('[data-rotate]').forEach(element => {
      const rotateTo = element.getAttribute('data-rotate');
      const initialRotation = window.getComputedStyle(element).transform.match(/rotate\(([^)]+)\)/);
      const initialRotateValue = initialRotation ? parseFloat(initialRotation[1]) : 0;

      gsap.to(element, {
        rotate: `${initialRotateValue + parseFloat(rotateTo)}deg`,
        scrollTrigger: {
          trigger: element,
          start: 'top top+=50%',
          end: 'bottom top',
          scrub: true
        }
      });
    });
  }

});